import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'src/app/models/user';
import Csv from 'csvtojson';
import { TeamService } from 'src/app/services/team.service';
import { UserService } from 'src/app/services/user.service';

export class ImportUserInfoComponent {
  constructor(
    public filePath: string,
    public users: User[]) { }
}

export interface UserKeyProperties {
  uid: string;
  key: string;
  name: string;
}

@Component({
  selector: 'app-import-user-dialog',
  templateUrl: './import-user-dialog.component.html',
  styleUrls: ['./import-user-dialog.component.css']
})

export class ImportUserDialogComponent implements OnInit {
  csvFullPath: string;
  // pickedFile: ReadFile;
  // readMode: ReadMode;
  content: string;
  parsedCsv: any[];
  submitting: boolean;
  constructor(
    public auth: AuthService,
    private dialogRef: MatDialogRef<ImportUserDialogComponent>,
    private teamService: TeamService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public keySet: ImportUserInfoComponent) {
      dialogRef.disableClose = true;
    }


  ngOnInit() {
    this.submitting = false;
  }

  async onSubmit() {
    this.submitting = true;
    // key重複チェック
    const isDuplicate = await this.isKeyDuplicateAfterChanges();

    if (isDuplicate) {
      this.dialogRef.close(null);
    } else {
      await Promise.all(this.parsedCsv.map(async (u) => {
        try {
          const user: User = {
            uid: u['uid'],
            email: u['email'],
            displayName: u['displayName'],
            kana: u['kana'],
            key: u['key'],
            id: u['id'],
            authority: +u['authority'],
            manageAuthority: +u['manageAuthority'],
            withoutYakusya: u['withoutYakusya'].toLowerCase() === 'TRUE'.toLowerCase() ? true : false,
            bugyoParallelOperation: u['bugyoParallelOperation'].toLowerCase() === 'TRUE'.toLowerCase() ? true : false
          };
          const password = u['password'];
          // UIDがCSVで空白なら、ユーザー追加。記載されているなら、該当ユーザーの更新処理を行う。
          user.team = await this.teamService.getTeamRef(u['teamName']);

          // TODO 個別登録ダイアログと同じ、メールアドレス・カードIDの重複チェック、POST結果のエラーチェックを追加する。

          if (user.uid === undefined || user.uid === '') {
            // 新規作成する。
            console.log(`create user ${user.displayName}`);
            await this.userService.createUser(user, password);
          } else {
            // 更新する。
            console.log(`update user ${user.displayName} ${user.uid} ${u['bugyoParallelOperation']} ${user.bugyoParallelOperation}`);
            await this.userService.updateUser(user);
          }
        } catch (err) {
          console.log(err);
        }
        return;
      }));
      this.dialogRef.close(true);
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onChangeInput(event) {
    this.parsedCsv = undefined;
    this.content = '';
    const file = event.target.files[0];
    // this.csvFullPath = file;
    this.fileToText(file)
      .then(async text => {
        this.parsedCsv = await Csv().fromString(text);

        // console.log(parsedCsv);

        this.parsedCsv.forEach(element => {
          this.content += JSON.stringify(element) + '\r\n';
        });
      })
      .catch(err => console.log(err));
  }


  fileToText(file): Promise<string> {
    const reader = new FileReader();
    // Excelで編集されたCSVを前提として、Shift-JISで読み込む。
    reader.readAsText(file, 'Shift-JIS');
    return new Promise((resolve, reject) => {
      reader.onload = () => {
        resolve(reader.result.toString());
      };
      reader.onerror = () => {
        reject(reader.error);
      };
    });
  }

  readFile() {
    const element = document.getElementById('hiddenFile') as HTMLElement;
    element.click();
  }

  isKeyDuplicateAfterChanges(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      // 重複判定用の一時配列
      const users: UserKeyProperties[] = [];
      // 既存ユーザーを先に一時配列に格納
      const userEx = await this.userService.getUsers();
      userEx.forEach(u => {
        users.push({
          uid: u.uid,
          key: u.key,
          name: u.displayName
        });
      });
      if (this.parsedCsv !== undefined) {
        this.parsedCsv.forEach(u => {
          const index = users.findIndex(item => {
            return (item.uid === u['uid'] && u['uid'] !== '' && u['uid'] !== undefined);
          });
          if (index === -1) {// 新規ユーザーの場合,uidを空文字列で一時配列に追加
            users.push({
              uid: '',
              key: u['key'],
              name: u['displayName']
            });
          } else {// 既存ユーザーの場合,keyの更新を行う
            users.splice(index, 1, {
              uid: u['uid'],
              key: u['key'],
              name: u['displayName']
            });
          }
        });
      }

      const duplicateUsers: UserKeyProperties[] = []; // 重複要素格納用
      const reverseUsers: UserKeyProperties[] = users.slice().reverse(); // 後方検索用
      const usersLength: number = users.length;

      // 前方検索と後方検索のインデックスが一致していれば、ユニークな要素として判定できる
      users.forEach((userX) => {
        const isUniq: boolean = (
          users.findIndex((userY) => { // 前方から検索
            return (userX.key === userY.key);
          }) === (usersLength - 1) - reverseUsers.findIndex((userY) => { // 後方から検索
            return (userX.key === userY.key);
          })
        ) && userX.key.trim() !== ''; // 空白・空文字列チェック
        if (!isUniq) {
          duplicateUsers.push(userX);
        }
      });

      // 重複・空白keyを持つユーザーがいれば
      if (duplicateUsers.length !== 0) {
        duplicateUsers.forEach((user) => {
          console.log(user.name, ' have duplicate ICcard key. key: ', user.key);
        });
        resolve(true);
      } else {
        resolve(false);
      }
    });
  }
  // onFilePicked(file: ReadFile) {
  //   this.pickedFile = file;
  //   this.csvFullPath = this.pickedFile.name;
  // }

  // onReadEnd(fileCount: number) {
  //   this.content = this.pickedFile.content;
  // }

  // filterFileBeforeReading(file: ReadFile) {
  //   const splittedName = file.name.split('.');
  //   const ext = splittedName[splittedName.length - 1];
  //   return (ext === 'csv' || ext === 'CSV');
  // }
}
